import { map } from 'rxjs/operators';
import { BehaviorSubject, fromEvent, Observable, Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { cloneDeep, filter, orderBy } from 'lodash';
import moment from 'moment';
import { NgxPermissionsService } from 'ngx-permissions';
import { AuthenticationService } from './authentication.service';
import { GeneralUtilsService } from './common/generalUtils.service';
import { SidebarMenu } from '../../../assets/data/enum/sidebarMenu';
import { NavMenu } from '../../../assets/data/enum/navMenu';
import { ThemeConfig } from '../../../assets/data/enum/themeConfig';
import { ButtonAction } from '../../../assets/data/enum/buttonAction';
import { StoreModelAction } from '../_models/storeModelAction';
import { StoreModel } from '../_models';
import { environment } from '../../../environments/environment';
import { SM } from '../../../assets/data/enum/storeModel.enum';
import { SAASBRANDNAME } from '../../../assets/data/enum/saasBrandName.enum';

export class NavBarMenu {
  itemLeft?: Array<any>;
  dropDownLeft?: Array<any>;
  itemRight?: Array<any>;
  dropDownRight?: Array<any>;
}

@Injectable()
export class StoreModelService implements OnDestroy {
  private apiBaseUrl = environment.apiBaseUrl;
  private apiSubscriptionUrl = environment.subscriptionServiceUrl;

  brand = SAASBRANDNAME;
  list: BehaviorSubject<Array<StoreModel>> = new BehaviorSubject<Array<StoreModel>>([]);
  farmMenu: BehaviorSubject<NavBarMenu> = new BehaviorSubject<NavBarMenu>(null);
  analyticsMenu: BehaviorSubject<NavBarMenu> = new BehaviorSubject<NavBarMenu>(null);
  guideList: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  indexRoute: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  resizeObservable$: Observable<Event>;
  menuGroupActive: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private subscriptions: Subscription = new Subscription();

  constructor(
    private http: HttpClient,
    private ngxPermissionsService: NgxPermissionsService,
    private generalUtilsService: GeneralUtilsService,
    private authService: AuthenticationService
  ) {
    const self = this;

    this.resizeObservable$ = fromEvent(window, 'resize');

    this.subscriptions.add(
      this.resizeObservable$.subscribe((event) => {
        if (!ThemeConfig.sidebar) {
          let nItem = 6;
          if (window.innerWidth < 1200) {
            nItem = 3;
          }
          this.generalUtilsService.refreshwebAPP = false;
          this.composeNavBarMenu(self.list.value, nItem);
        }
      })
    );
  }

  getStoreModels(): Observable<StoreModel[]> {
    const url =
      ThemeConfig.brand === this.brand.HUBFARM
        ? this.apiBaseUrl + 'api/private/v3/store/storeModels'
        : this.apiSubscriptionUrl + 'api/private/v4/store/storeModels';

    return this.http.get<StoreModel[]>(url).pipe(
      map((response) => {
        if (response) {
          const filterResponse = this.forceDisableStoreModel(response);
          this.list.next(filterResponse);
          this.updatePermissionService(filterResponse);
          if (ThemeConfig.sidebar) {
            this.composeSideBarMenu(filterResponse);
          } else {
            let nItem = 6;
            if (window.innerWidth < 1200) {
              nItem = 3;
            }
            this.composeNavBarMenu(filterResponse, nItem);
          }
          return filterResponse;
        }

        return [];
      })
    );
  }

  updatePermissionService(storeModels: Array<StoreModel>) {
    storeModels.forEach((element) => {
      this.ngxPermissionsService.addPermission(element.roleGranted.toUpperCase());
    });
  }

  enableActionByStoreModelAndPermission = (storeModel: string): StoreModelAction => {
    const result: StoreModelAction = new StoreModelAction();
    if (this.list.value && this.list.value.length > 0) {
      const storeModelResult = filter(this.list.value, (sm: StoreModel) => {
        return sm.roleGranted === storeModel;
      });
      if (storeModelResult && storeModelResult.length > 0) {
        if (
          storeModelResult[0].expirationDate &&
          storeModelResult[0].expirationDate !== null &&
          storeModelResult[0].expirationDate !== undefined &&
          !this.isExpired(moment(storeModelResult[0].expirationDate as any))
        ) {
          if (storeModelResult[0].permissions) {
            const permission: any = storeModelResult[0].permissions;
            result.create = permission && permission.create ? permission.create : false;
            result.read = permission && permission.read ? permission.read : false;
            result.update = permission && permission.update ? permission.update : false;
            result.delete = permission && permission.delete ? permission.delete : false;
            return result;
          }
        }
      }
      return result;
    }
    return result;
  };

  enableActionByStoreModelPROAndPermission = (storeModel: string): StoreModelAction => {
    // tslint:disable-next-line:prefer-const
    const result: StoreModelAction = new StoreModelAction();
    const buttonAction = ButtonAction;
    if (this.list.value && this.list.value.length > 0) {
      const storeModelResult = filter(this.list.value, (sm: StoreModel) => {
        return sm.roleGranted === storeModel;
      });
      if (storeModelResult && storeModelResult.length > 0) {
        if (
          storeModelResult[0].expirationDate &&
          storeModelResult[0].expirationDate !== null &&
          storeModelResult[0].expirationDate !== undefined &&
          !this.isExpired(moment(storeModelResult[0].expirationDate as any))
        ) {
          if (storeModelResult[0].permissions) {
            const permission: any = storeModelResult[0].permissions;
            result.create = permission && permission.create ? permission.create : false;
            result.read = permission && permission.read ? permission.read : false;
            result.update = permission && permission.update ? permission.update : false;
            result.delete = permission && permission.delete ? permission.delete : false;
            result.purchased = true;
            return result;
          }
        } else if (
          !storeModelResult[0].expirationDate ||
          storeModelResult[0].expirationDate === null ||
          storeModelResult[0].expirationDate === undefined ||
          this.isExpired(moment(storeModelResult[0].expirationDate as any))
        ) {
          if (storeModelResult[0].permissions) {
            const permission: any = storeModelResult[0].permissions;
            result.create = permission && permission.create ? permission.create : false;
            result.read = permission && permission.read ? permission.read : false;
            result.update = permission && permission.update ? permission.update : false;
            result.delete = permission && permission.delete ? permission.delete : false;
            result.purchased = false;
            return result;
          }
        }
      }
      return result;
    }
    return result;
  };

  enableActionByStoreModelAndAction = (storeModel: any, action: string): boolean => {
    let result = false;
    const buttonAction = ButtonAction;
    let storeModelResult: StoreModel[];
    if (this.list.value && this.list.value.length > 0) {
      if (storeModel) {
        if (Array.isArray(storeModel)) {
          storeModel.forEach((elementStoreModel) => {
            const storeModelArrayTemp = filter(this.list.value, (sm: StoreModel) => {
              return sm.roleGranted === elementStoreModel;
            });

            if (
              storeModelArrayTemp.length > 0 &&
              storeModelArrayTemp[0]?.expirationDate &&
              !this.isExpired(moment(storeModelArrayTemp[0].expirationDate as any))
            ) {
              storeModelResult = storeModelArrayTemp;
            }
          });
        } else {
          const storeModelArrayTemp = filter(this.list.value, (sm: StoreModel) => {
            return sm.roleGranted === storeModel;
          });

          if (
            storeModelArrayTemp.length > 0 &&
            storeModelArrayTemp[0]?.expirationDate &&
            !this.isExpired(moment(storeModelArrayTemp[0].expirationDate as any))
          ) {
            storeModelResult = storeModelArrayTemp;
          } else {
            storeModelResult = [];
          }
        }

        if (storeModelResult && storeModelResult.length > 0) {
          if (
            storeModelResult[0].expirationDate &&
            storeModelResult[0].expirationDate !== null &&
            storeModelResult[0].expirationDate !== undefined &&
            !this.isExpired(moment(storeModelResult[0].expirationDate as any))
          ) {
            if (storeModelResult[0].permissions) {
              const permission: any = storeModelResult[0].permissions;
              if (permission.create && action === buttonAction.CREATE) {
                result = permission.create;
              }
              if (permission.read && action === buttonAction.READ) {
                result = permission.read;
              }
              if (permission.update && action === buttonAction.UPDATE) {
                result = permission.update;
              }
              if (permission.delete && action === buttonAction.DELETE) {
                result = permission.delete;
              }

              return result;
            }
          }
        }
        return result;
      }
    }
    return result;
  };

  isExpired = (expirationDate): boolean => {
    const currentTimeStamp = moment().utc();
    return !expirationDate.isAfter(currentTimeStamp);
  };

  isStoreModelProActive(storeModel: StoreModel): boolean {
    return storeModel.expirationDate && !this.isExpired(moment(storeModel.expirationDate as any));
  }

  composeNavBarMenu = (storeModels: Array<StoreModel>, spliceLimit = 6) => {
    this.generalUtilsService.globalUIMode.subscribe((mode) => {
      let fullConfigurationMenu: Array<any> = NavMenu;
      fullConfigurationMenu = filter(cloneDeep(fullConfigurationMenu), (item: any) => {
        return item.enableModeList.includes(mode);
      });
      // tslint:disable-next-line:prefer-const
      const navBarMenu: NavBarMenu = new NavBarMenu();
      if (fullConfigurationMenu && fullConfigurationMenu.length > 0) {
        fullConfigurationMenu.forEach((item) => {
          if (item && item.children && item.children.length > 0) {
            item.children.forEach((ic) => {
              // tslint:disable-next-line:prefer-const
              const resultFiltered = filter(storeModels, ['roleGranted', ic.storeModel]);
              if (resultFiltered && resultFiltered.length > 0) {
                ic.storeModelObj = resultFiltered[0];
              }
            });
          } else {
            let resultFiltered;
            // tslint:disable-next-line:prefer-const
            if (item.storeModel.constructor.name === 'Array') {
              for (let i = 0; i < item.storeModel.length; i++) {
                resultFiltered = filter(storeModels, ['roleGranted', item.storeModel[i]]);
                if (resultFiltered && resultFiltered.length > 0) {
                  item.storeModelObj = resultFiltered[0];
                  break;
                }
              }
            } else {
              resultFiltered = filter(storeModels, ['roleGranted', item.storeModel]);
              if (resultFiltered && resultFiltered.length > 0) {
                item.storeModelObj = resultFiltered[0];
              }
            }
          }
        });

        navBarMenu.itemLeft = orderBy(
          filter(filter(cloneDeep(fullConfigurationMenu), ['type', 'item_left']), (itemNav) => {
            return this.enableActionByStoreModelAndAction(itemNav.storeModel, ButtonAction.READ);
          }),
          ['order'],
          ['asc']
        );

        if (navBarMenu.itemLeft.length > spliceLimit) {
          const menuDropdownLeftList = navBarMenu.itemLeft.splice(
            spliceLimit,
            navBarMenu.itemLeft.length - 1
          );
          const dropDownItem = {
            order: spliceLimit,
            type: 'dropdown_left',
            label: 'navbar.item6',
            iconClass: null,
            hrefLink: null,
            routerLink: null,
            storeModel: null,
            children: menuDropdownLeftList,
          };
          navBarMenu.itemLeft.push(dropDownItem);
        }

        const initDropDownLeft: any = filter(cloneDeep(navBarMenu.itemLeft), [
          'type',
          'dropdown_left',
        ]);
        if (initDropDownLeft && initDropDownLeft.length > 0 && initDropDownLeft[0].children) {
          const initDropDownLeftChildren: Array<any> = initDropDownLeft[0].children;
          navBarMenu.dropDownLeft = orderBy(
            filter(filter(initDropDownLeftChildren), (itemNav) => {
              return this.enableActionByStoreModelAndAction(itemNav.storeModel, ButtonAction.READ);
            }),
            ['order'],
            ['asc']
          );
        }

        navBarMenu.itemRight = orderBy(
          filter(filter(cloneDeep(fullConfigurationMenu), ['type', 'item_right']), (itemNav) => {
            return this.enableActionByStoreModelAndAction(itemNav.storeModel, ButtonAction.READ);
          }),
          ['order'],
          ['asc']
        );

        const initDropDownRight: any = filter(cloneDeep(fullConfigurationMenu), [
          'type',
          'dropdown_right',
        ]);
        if (initDropDownRight && initDropDownRight.length > 0 && initDropDownRight[0].children) {
          const initDropDownRightChildren: Array<any> = initDropDownRight[0].children;
          navBarMenu.dropDownRight = orderBy(
            filter(filter(initDropDownRightChildren), (itemNav) => {
              return this.enableActionByStoreModelAndAction(itemNav.storeModel, ButtonAction.READ);
            }),
            ['order'],
            ['asc']
          );
        }
      }

      this.farmMenu.next(navBarMenu);

      if (
        navBarMenu &&
        navBarMenu.itemLeft &&
        navBarMenu.itemLeft[0] &&
        navBarMenu.itemLeft[0].routerLink
      ) {
        this.indexRoute.next(navBarMenu.itemLeft[0].routerLink);
      }
    });
  };

  composeSideBarMenu = (storeModels: Array<StoreModel>) => {
    this.generalUtilsService.globalUIMode.subscribe((mode) => {
      let fullConfigurationMenu: Array<any> = SidebarMenu;

      const navBarMenu: NavBarMenu = new NavBarMenu();
      if (fullConfigurationMenu && fullConfigurationMenu.length > 0) {
        // If we are in Analytics mode we do not want to filter out the sidebar items, based on the mode (i.e. Farm or Livestock)
        // Analytics is currently only for FARM
        // A method in the data.service will update the globalUIMode to FARM
        if (!ThemeConfig.isAnalyticsMode) {
          fullConfigurationMenu = filter(cloneDeep(fullConfigurationMenu), (item: any) => {
            return item.enableModeList.includes(mode);
          });
        }
        fullConfigurationMenu.forEach((item) => {
          const resultFiltered = filter(storeModels, ['roleGranted', item.storeModel]);
          if (resultFiltered && resultFiltered.length > 0) {
            item.storeModelObj = resultFiltered[0];
          }
        });

        fullConfigurationMenu.forEach((itemNav) => {
          itemNav.isProEnabled = this.enableActionByStoreModelAndAction(
            itemNav.storeModel,
            ButtonAction.READ
          );
        });

        navBarMenu.itemLeft = orderBy(
          filter(cloneDeep(fullConfigurationMenu), ['type', 'item_left']),
          ['order'],
          ['asc']
        );

        const initDropDownRight: any = filter(cloneDeep(fullConfigurationMenu), [
          'type',
          'dropdown_right',
        ]);
        if (initDropDownRight && initDropDownRight.length > 0 && initDropDownRight[0].children) {
          const initDropDownRightChildren: Array<any> = initDropDownRight[0].children;
          navBarMenu.dropDownRight = orderBy(
            filter(filter(initDropDownRightChildren), (itemNav) => {
              return this.enableActionByStoreModelAndAction(itemNav.storeModel, ButtonAction.READ);
            }),
            ['order'],
            ['asc']
          );
        }
      }

      if (navBarMenu && navBarMenu.itemLeft) {
        navBarMenu.itemLeft = filter(navBarMenu.itemLeft, (item) => {
          return (
            item.storeModelObj &&
            item.storeModelObj.permissions &&
            item.storeModelObj.permissions.read === true
          );
        });
      }
      if (ThemeConfig.isAnalyticsMode === true) {
        navBarMenu.itemLeft = navBarMenu.itemLeft.filter(
          (item) => ![SM.SM_SURVEY, SM.SM_EQUIPMENT].includes(item.storeModel)
        );
      }
      if (
        navBarMenu &&
        navBarMenu.itemLeft &&
        navBarMenu.itemLeft[0] &&
        navBarMenu.itemLeft[0].routerLink
      ) {
        if (navBarMenu.itemLeft[0].storeModelObj.type == 'FREE') {
          this.indexRoute.next(navBarMenu.itemLeft[0].routerLink);
          //Behaviour Subj. used to determine which MenuGroup to be expanded at the login
          this.menuGroupActive.next(navBarMenu.itemLeft[0].menuGroup);
        } else {
          // if first voice of menu is not a FREE module try to navigate to the first valid and enabled route
          let firstvalidRoute = null;
          navBarMenu.itemLeft.forEach((i) => {
            if (firstvalidRoute == null) {
              if (i.storeModelObj.type == 'FREE') {
                firstvalidRoute = i;
              } else if (i.storeModelObj.type == 'PRO' && i.isProEnabled == true) {
                firstvalidRoute = i;
              }
            }
          });
          if (firstvalidRoute && firstvalidRoute.routerLink) {
            this.indexRoute.next(firstvalidRoute.routerLink);
            //Behaviour Subj. used to determine which MenuGroup to be expandend at the login
            this.menuGroupActive.next(firstvalidRoute.menuGroup);
          } else {
            this.authService.logout();
          }
        }
      }

      this.analyticsMenu.next(navBarMenu);
    });
  };

  getStoreModelGuide(): Observable<any> {
    return this.http.get<any>(this.apiBaseUrl + 'api/public/v1/store/storeModels').pipe(
      map((response) => {
        if (response) {
          this.guideList.next(response);
          return response;
        }

        return [];
      })
    );
  }

  forceDisableStoreModel = (storeModels: Array<StoreModel>) => {
    const filterStoreModel = [];
    const { forceHideFunctionalityList } = ThemeConfig;

    if (ThemeConfig.isAnalyticsMode == false) {
      storeModels.forEach((model) => {
        if (!forceHideFunctionalityList.includes(model.roleGranted)) {
          filterStoreModel.push(model);
        }
      });
    } else {
      const analyticsEnabledModule: Array<string> = ThemeConfig.forceShowFunctionalityList;
      storeModels.forEach((model) => {
        if (analyticsEnabledModule.includes(model.roleGranted)) {
          filterStoreModel.push(model);
        }
      });
    }
    return filterStoreModel;
  };

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
